// @ts-strict-ignore
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';

export type MountingRailCreationStatus = 'mountingRailLoading'
  | 'mountingRailCompleted'
  | 'startZoneLoading'
  | 'endZoneLoading';

export type MountingRailCarrierType = 'leadingEnd' | 'leadingStart' | 'leadingBoth' | 'leftOpenSide' | 'rightOpenSide';

export class MountingRailCreationModel {

  public static readonly LEADING_END: string = 'leadingEnd';
  public static readonly LEADING_START: MountingRailCarrierType = 'leadingStart';
  public static readonly LEADING_BOTH: MountingRailCarrierType = 'leadingBoth';
  public static readonly LEFT_OPEN_SIDE: MountingRailCarrierType = 'leftOpenSide';
  public static readonly RIGHT_OPEN_SIDE: MountingRailCarrierType = 'rightOpenSide';

  public currentState: MountingRailCreationStatus = 'mountingRailCompleted';
  private _startBlockingLength: number = 0;
  private _endBlockingLength: number = 0;
  public drillingHoleOffset: number = 0;
  public existingDrillingHoleOffset: number = 0;
  public usedMountingRailLength: number = 0;
  public compoundedUsedMountingRailLength: number = 0;
  public leadingMeasurement: MountingRailCarrierType = MountingRailCreationModel.LEADING_START;
  public openSide: MountingRailCarrierType = MountingRailCreationModel.RIGHT_OPEN_SIDE;
  public hasDrillingholePreset: boolean = false;
  public lengthInput: string;

  public onCompleteHandlers: Function[] = [];

  public newArticle: ArticleVO;
  public oldArticle: ArticleVO;

  public maxMountingRailLength: number = 0;
  private _mountingRailLength: number = 0;

  public mountingRailArticle: ArticleVO;
  public mountingRailUsage: ArticleUsageVO;
  public existingMountingRail: ArticleContainer;

  public blockingZoneArticle: ArticleVO;
  public connectedArticles: ArticleContainer[] = [];

  public startBlockingZoneArticleContainer: ArticleContainer;
  public endBlockingZoneArticleContainer: ArticleContainer;
  public hasDrillingHolePreset: boolean;

  public createBlockingZones: boolean = true;
  public updateDrillingHoles: boolean = false;

  public get startBlockingLength() {
    return this._startBlockingLength;
  }

  public get endBlockingLength() {
    return this._endBlockingLength;
  }

  public get mountingRailLength() {
    return this._mountingRailLength;
  }

  /**
   * Set this value in 3DUnits, not in mm
   * @param value
   */
  public set startBlockingLength(value: number) {
    this._startBlockingLength = value;
  }

  /**
   * Set this value in 3DUnits, not in mm
   * @param value
   */
  public set endBlockingLength(value: number) {
    this._endBlockingLength = value
  }

  /**
   * Set this value in 3DUnits, not in mm
   * @param value
   */
  public set mountingRailLength(value: number) {
    this._mountingRailLength = value;
  }
}
